import PropTypes from 'prop-types';
import { Input, Button } from 'antd';
import { Action } from '../data/useReviewEditor';
import ReviewStepHeader from '../UI/ReviewStepHeader';
import './reviewTextEditor.less';
import CommunityGuidelinesLink from '../../../UI/Links/CommunityGuidelines/CommunityGuidelinesLink';

const { TextArea } = Input;

ReviewTextEditor.propTypes = {
	reviewEditor: PropTypes.object,
};

export default function ReviewTextEditor({ reviewEditor }) {
	const handleChange = evt => {
		const action = {
			type: Action.SET_EDITOR_VALUE,
			payload: evt.currentTarget.value,
		};
		reviewEditor.update(action);
	};

	const handleReset = () => {
		const action = {
			type: Action.RESET_EDITOR_VALUE,
		};
		reviewEditor.update(action);
	};

	const names = 'review-text-editor editor-root';

	return (
		<div className={names} style={{ marginTop: '2rem' }}>
			<ReviewStepHeader icon="form" label="Review (2/3)" />
			<div>
				<TextArea
					rows={8}
					placeholder="Write your review here"
					onChange={handleChange}
					value={reviewEditor.getEditorValue()}
				/>
				<CommunityGuidelinesLink />
			</div>
			{reviewEditor.didEdit() && (
				<div className="review-reset">
					<Button onClick={handleReset}>Reset</Button>
				</div>
			)}
		</div>
	);
}
